import { render } from "./CreateLiquidation5.vue?vue&type=template&id=f3a60de0"
import script from "./CreateLiquidation5.vue?vue&type=script&lang=js"
export * from "./CreateLiquidation5.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__